import React from "react";
import { Play, Film, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const ArchiveSection = ({ tapes, onSelectTape }) => {
  return (
    <section
      id="archive"
      className="relative py-24 md:py-32 border-t border-[#1f1a15]"
      style={{
        background:
          "linear-gradient(180deg, #0e0b09 0%, #100c0a 60%, #0e0b09 100%)",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div className="reveal">
            <div className="text-[11px] mono uppercase tracking-[0.3em] text-[#f5b14e]">
              ▶ The Archive / Full Catalog
            </div>
            <h2
              className="mt-3 text-5xl md:text-6xl"
              style={{ fontFamily: "'Instrument Serif', serif" }}
            >
              Every tape, <em className="not-italic text-[#f5b14e]">rewound.</em>
            </h2>
          </div>
          <div className="text-[11px] mono text-[#f2ece1]/50 reveal">
            {tapes.length.toString().padStart(2, "0")} entries · shelf order ↓
          </div>
        </div>

        <div className="mt-10 md:mt-14 border-t border-[#2a221b]">
          {tapes.map((t, i) => (
            <div
              key={t.id}
              role="button"
              tabIndex={0}
              onClick={() => onSelectTape(t)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelectTape(t)}
              className="reveal group w-full text-left grid grid-cols-12 items-center gap-4 py-6 md:py-7 border-b border-[#2a221b] hover:bg-[#120e0a] transition-colors px-2 md:px-4 cursor-pointer"
            >
              <div className="col-span-1 text-[11px] mono text-[#f2ece1]/40">
                {(i + 1).toString().padStart(2, "0")}
              </div>
              <div className="col-span-11 md:col-span-6">
                <div
                  className="text-2xl md:text-3xl leading-tight"
                  style={{ fontFamily: "'Instrument Serif', serif" }}
                >
                  {t.title}
                </div>
                <div className="text-[11px] mono uppercase tracking-widest text-[#f2ece1]/50 mt-1">
                  {t.subtitle}
                </div>
              </div>
              <div className="hidden md:flex col-span-2 items-center gap-2 text-[12px] mono text-[#f2ece1]/70">
                <span
                  className="w-2 h-2 rounded-full"
                  style={{ background: t.spine }}
                />
                {t.category}
              </div>
              <div className="hidden md:block col-span-1 text-[12px] mono text-[#f2ece1]/70">
                {t.runtime}
              </div>
              <div className="col-span-12 md:col-span-2 flex md:justify-end items-center gap-3 text-[12px] mono uppercase tracking-widest text-[#f2ece1]/60 group-hover:text-[#f5b14e] transition-colors">
                <span className="inline-flex items-center gap-2">
                  <Play className="w-3.5 h-3.5" /> Play
                </span>
                <Link
                  to={`/tape/${t.id}`}
                  onClick={(e) => e.stopPropagation()}
                  className="inline-flex items-center gap-1 border-l border-[#2a221b] pl-3 hover:text-[#f5b14e]"
                >
                  Details <ArrowUpRight className="w-3 h-3" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 flex items-center justify-center gap-3 text-[11px] mono uppercase tracking-widest text-[#f2ece1]/45">
          <Film className="w-4 h-4" /> End of Side A — rewind to top
        </div>
      </div>
    </section>
  );
};

export default ArchiveSection;
